import VariablesLabels from "./VariablesLabels";
import utils from "../../app/utils";
import broadcast from "../../app/broadcast";
import store from "../../app/store";
import EmptyLabels from "./EmptyLabels";
import TempDataHandler from "./TempDataHandler";
import WindDataHandler from "./WindDataHandler";
import AqiDataHandler from "./AqiDataHandler";

import "../../../../maps-frontend/assets/css/plugins/poi-libs/infopoi.scss";
import infopoihtml from "../../../../maps-frontend/modules/templates/plugins/poi-libs/infopoi.pug"
import rootScope from "../../app/rootScope";

/**
 * Código del plugin que contiene el HTML de la ventana de detalles.
 * @type {Object}
 */
export const plugincode={html: infopoihtml({
        domain: rootScope.resourcesServer
    })};


const variableLabels = new VariablesLabels();
const tempStationsLabels = new TempDataHandler();
const windStationsLabels = new WindDataHandler();
const aqiStationsLabels = new AqiDataHandler();

const pois = {
    empty: new EmptyLabels(),
    symbols: new EmptyLabels(),
    // favs: Bt,
    cities: variableLabels,
    // cams: Zt,
    // tide: Vt,
    // metars: Yt,
    // radiosonde: Wt,
    temp: tempStationsLabels,
    wind: windStationsLabels,
    aqi: aqiStationsLabels
    // precip: Qt,
    // radiation: Kt,
    // airq: $t,
    // kitespots: Jt,
    // pgspots: to,
    // surfspots: oo,
    // firespots: io
};

let selectedPois = "empty";

function changePois(namepois) {
    if(selectedPois !== namepois) {
        utils.replaceClass(/selectedpois-\S+/, "selectedpois-".concat(namepois));
        if ("favs" !== selectedPois)
            pois[selectedPois].deactivate.call(pois[selectedPois]);
        if("favs" !== namepois) {
            pois[namepois].activate.call(pois[namepois]);
        }
        selectedPois = namepois
    }
}


// function ao(t, o) {
//     if("empty" === t || "cams" === t && o)
//         pois.favs.deactivate.call(pois.favs)
//     else
//         pois.favs.activate.call(pois.favs);
// }
function setTempPois(pois) {
    if("empty" === pois)
        changePois(store.get("pois"))
    else
        changePois(pois);
}

function redrawPois() {
    const poi = pois[selectedPois];
    poi.redraw.call(poi);
}

const redrawPoisDebounce = utils.debounce(
    redrawPois
, 100);


broadcast.on("paramsChanged", redrawPoisDebounce);
store.on("radarTimestamp", redrawPois);
broadcast.on("mapChanged", redrawPoisDebounce);
broadcast.on("metricChanged",
    function() {
        const poi = pois[store.get("pois")];
        poi.redraw.call(poi, true);
    }
);
store.on("pois", changePois);
store.on("poisTemporary", setTempPois);
store.on("aqioverlay", redrawPoisDebounce);

// store.on("pois",
//     function(t) {
//         return ao(t, store.get("camsPreviews"))
//     }
// );
// store.on("camsPreviews",
//     function(t) {
//         return ao("cams", t)
//     }
// );

setTempPois(store.get("poisTemporary"));
// ao(store.get("pois"), store.get("camsPreviews"));

export default {
    getParams() {
        // let t;
        //
        // if (pickerInstance){
        //     t = pickerInstance.getParams()
        //     return t ? t: null;
        // }else
        //     return {
        //         lat: 0,
        //         lon: 0
        //     }
    },

    onclose() {
        // const t = pickerInstance;
        //
        // if (t)
        //     t.close();
    },


    onopen (t) {
        // const e = pickerInstance;
        // if ("singleclick" === t.source && e)
        //     e.clickOnMap(t)
        // else
        //     pickerInstance.open(t.lat, t.lon, Boolean(t.noEmit));
    }
}



